const configGoogleClientId =
	process.env.GOOGLE_CLIENT_ID ||
	'204022966086-rnursb87237sg6699bptfr0sjsma6vl0.apps.googleusercontent.com'
export default configGoogleClientId
